import {LoaderProps} from './types'
import {getIcon} from './utils'

export const Loader = (props: LoaderProps) => {
  const {size = 'regular'} = props
  return getIcon(size)
}
